
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            ¿Estas seguro de eliminar la inscripción?
          </h4>
        </template>

        <div>
            <p class="mb-1" v-if="row && row.persona && row.persona.nombres">Nombre <strong>{{row.persona.nombres}} {{row.persona.apellido_paterno}} {{row.persona.apellido_materno}}</strong></p>
            <p class="mb-1" v-if="row && row.persona && row.persona.matricula">Matrícula <strong>{{row.persona.matricula}}</strong></p>
            <md-chip v-if="row.programa === null" class="mb-1 fontMedium mini-chip col-yellow">
                <strong>
                    <span>No inscripto</span>
                </strong>
            </md-chip>
            <md-chip v-else class="mb-1 fontMedium mini-chip col-green">
                <strong>
                    <span>Inscrito</span>
                </strong>
            </md-chip>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                        style="width: 95%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        @click="getEliminar()"
                        style="width: 95%"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import servicios from '../../../../api/requests/servicios'
export default {
    props:[
    'value',
    'row',
    'ciclo',
    'institucion'
    ],
    data(){
        return{
        active: false,
        email: '',
        password: '',
        remember: false
        }
    },
    methods: {
        async getEliminar(){
                const loading = this.$vs.loading()
            try { 
                const personaId = this.row.persona_id
                const formData = new FormData();
                formData.append('institucion', this.institucion)
                formData.append('ciclo_escolar', this.ciclo)
                formData.append('persona_id', personaId)
                const response = await servicios.getEliminarInscripcion(formData)
                loading.close()
                this.$emit('refreshTable')
                this.active = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                })
            }catch(error){
                loading.close()
                if(error.response.data.message){
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un problema',
                        text: error.response.data.message
                    })
                }else{
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un problema',
                        text: 'Favor de contactar al administrador'
                    })
                }
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>

<style>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>